var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemplersProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02657f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49415,
    stopColor: "#023d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99468,
    stopColor: "#02244d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.41413,33.57586l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.7351,41.82896l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.64181,51.81206l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.20432 51.24089 61.55945 47.45336 68.91458 51.24089 73.98867 58.85178 75.26921 57.99808 69.97368 50.05503 61.55945 45.72242 53.14522 50.05503 47.85019 57.99808 49.13073 58.85178 54.20432 51.24089"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.75923,59.31539l-4.04614-6.06926-6.15355-3.16871-6.15355,3.16871-4.04614,6.06926v11.79051h-3.28171v1.53906h26.96312v-1.53906h-3.28203v-11.79051ZM60.4561,66.42584l-4.49362,4.37517v-8.75034l4.49362,4.37517ZM61.55945,67.5001l3.70343,3.6058h-7.40686l3.70343-3.6058ZM62.6628,66.42584l4.49384-4.37539v8.75078l-4.49384-4.37539ZM66.0531,60.97638l-4.49366,4.3752-4.49366-4.3752h8.98731Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemplersProductsScraper);
export default __webpack_public_path__ + "static/media/gemplers-products-scraper.853f56467649b2309c6f06d748b474d3.svg";
export { ForwardRef as ReactComponent };